// extracted by mini-css-extract-plugin
module.exports = {"complete":"style-module__complete___1qfGX","inProgress":"style-module__inProgress___3DmqC"};